import QIcon from '@/components/standard/display/QIcon'
import InputButton from '@/components/standard/input/InputButton'
import ChannelList from '@/components/standard/channels/ChannelList'

import dc from '@/assets/modules/events/discountCalculator'

export default {
  methods: {
    editPost (e) {
      this.$router.push({
        name: 'advertisableEditor',
        params: {postId: this.uid}
      })
    },
    deletePost (e) {
      this.$emit('deletePost', { id: this.uid })
    },

    selectBox () {
      if (!this.selectable) return

      this.$emit('selected', {
        type: this.type,
        selected: !this.selected,
        id: this.uid
      })
    },
  },

  computed: {
    getPrice () {
      return Math.round(this.price * 100) / 100
    },
    
    getDiscountedPrice () {
      return dc.getDiscountedPrice(this.getPrice, this.discount, this.imported)
    },

    getDiscount () {
      return dc.getDiscount(this.discount) || {}
    },

    getDiscountSymbol () {
      return this.getDiscount.relative ? '%' : '€'
    },

    /**
     * Gives the display discount
     * @returns {String|undefined}
     */
    getAdvertisableDisplayDiscount () {
      let { discount, discountSymbol } = dc.getDiscount(this.discount)
      if (discount) {
        return `-${discount}${discountSymbol}`
      }
    },

    getQuantity () {
      // Tmp.
      return false
    },

    isOferlayShown () {
      return this.selectable || this.editable
    },
    getPostPricingStyle () {
      let base = `post-pricing`
      if (this.selected) {
        base = `selected ${base}`
      }
      return base
    },
    getPostContentStyle () {
      let base = `post-content`
      if (this.selected) {
        base = `selected ${base}`
      }
      return base
    },
    getOverlayClass () {
      let base = 'position-absolute overlay-bg'
      base += this.selected ? ' overlay-shown' : ' overlay-hover'
      return base
    },
    getConnectedClass () {
      let base = 'icon-plain'
      if (this.selected) {
        base += ' raised'
      }
      return base
    },
  },

  props: {
    image: {
      type: String,
      required: false,
      default: ''
    },
    selected: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    discount: {
      type: Number,
      required: false,
      default: null
    },
    price: {
      type: Number,
      required: false,
      default: 0.0
    },
    selectable: {
      type: Boolean,
      required: false,
      default: false
    },
    editable: {
      type: Boolean,
      required: false,
      default: false
    },
    uid: {
      required: false
    },
    imported: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  components: {
    'q-icon': QIcon,
    'input-button': InputButton,
    'channel-list': ChannelList
  }
}



// WEBPACK FOOTER //
// ./src/mixins/service/postList/item.js